var map = {
	"./capa_fachada.jpg": 322,
	"./fachada1.jpg": 323,
	"./fachada2.jpg": 324,
	"./fachada3.jpg": 325,
	"./fachada4.jpg": 326,
	"./fachada5.jpg": 327
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Fachada nonrecursive \.(jpg|jpeg|png|gif)$
// module id = 16
// module chunks = 0